import getUserFirstAndLastName from '@helpers/getUserFirstAndLastName';

const renderParticipantsNames = (participants: { name?: string | null }[], total?: number, maxLength?: number, isJoin?: boolean): string => {
  const namedParticipants = participants.filter(participant => !!participant.name);
  const participantsNames = namedParticipants.map(participant => {
    const name = getUserFirstAndLastName(participant.name);
    return `${name.firstName}${name.lastName ? ` ${name.lastName.charAt(0).toUpperCase()}.` : ''}`;
  });

  if (participantsNames.length > (maxLength || 2)) {
    return `${isJoin ? 'Join with ' : ''}${participantsNames.slice(0, (maxLength || 2)).join(', ')} and ${(total || participantsNames.length) - (maxLength || 2)} ${isJoin ? 'others!' : 'others are discussing'}`;
  }

  if (participantsNames.length === (maxLength || 2)) {
    return isJoin ? `Join with ${participantsNames.join(' and ')}` : `${participantsNames.join(' and ')} are discussing`;
  }

  if (participantsNames.length > 0) {
    return isJoin ? `Join with ${participantsNames.join(', ')}` : `${participantsNames.join(', ')} has commented`;
  }

  return "";
};

export default renderParticipantsNames;
